import { CropDeleteConfirmDialogProps } from "@/app/activity/detail/cropDeleteConfirmDialog/type"
import Dialog from "@/components/dialog/Dialog"
import { useTranslation } from "react-i18next"

export default function CropDeleteConfirmDialog({
  data,
  isOpen,
  onConfirm,
  onCancel,
}: CropDeleteConfirmDialogProps) {
  const { t } = useTranslation("")

  return (
    <Dialog
      maxWidth="400px"
      open={isOpen}
      title={t("confirm")}
      confirmTextKey="apply"
      onClose={onCancel}
      onConfirm={() => onConfirm(data)}>
      <div className="CropDeleteConfirmDialogCont">{t("messages.confirmRefillCrop")}</div>
    </Dialog>
  )
}
